"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Icon = void 0;

var _react = _interopRequireWildcard(require("react"));

var _coreNumberBadge = _interopRequireDefault(require("@legacy-vfuk/core-number-badge"));

var _styledComponents = require("styled-components");

var Styled = _interopRequireWildcard(require("./styles/Icon.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var Icon = /*#__PURE__*/function (_PureComponent) {
  _inherits(Icon, _PureComponent);

  var _super = _createSuper(Icon);

  function Icon() {
    var _this;

    _classCallCheck(this, Icon);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.checkRuleFields = function () {
      // If the icon group does not exist then return true
      if (!_this.props.theme.doesIconGroupExist(_this.props.group)) return true;

      var iconProperties = _this.props.theme.getIconProperties(_this.props.group);

      var errors = new Set(); // Checks if it has an appearance, and if it does check whether the appearance is valid

      if (iconProperties.appearance) {
        errors.add(!iconProperties.appearance[_this.props.appearance]);
      } // Checks if it has a state, and if it does check whether the state is valid


      if (iconProperties.state && _this.props.state) {
        errors.add(!iconProperties.state[_this.props.state]);
      } // Checks if there are any errors, if so then return true


      return errors.has(true);
    };

    return _this;
  }

  _createClass(Icon, [{
    key: "render",
    value: function render() {
      if (this.checkRuleFields()) return /*#__PURE__*/_react["default"].createElement(Styled.ErrorPinkBox, null);
      return /*#__PURE__*/_react["default"].createElement(Styled.Icon, {
        state: this.props.state,
        "aria-hidden": "true",
        appearance: this.props.appearance,
        inverse: this.props.inverse,
        size: this.props.size,
        isResponsive: this.props.isResponsive,
        group: this.props.group
      }, this.props.theme.getIcon(this.props.name, this.props.group, /*#__PURE__*/_react["default"].createElement(Styled.ErrorPinkBox, null)), this.props.numberBadge && this.props.group === 'system' && /*#__PURE__*/_react["default"].createElement(Styled.NumberBadgeContainer, null, /*#__PURE__*/_react["default"].createElement(_coreNumberBadge["default"], {
        number: this.props.numberBadge.number,
        appearance: this.props.inverse ? this.props.numberBadge.appearance : 'primary'
      })));
    }
  }]);

  return Icon;
}(_react.PureComponent);

exports.Icon = Icon;
Icon.defaultProps = {
  isResponsive: true,
  appearance: 'primary',
  inverse: false,
  group: 'system'
};
Icon.displayName = "Icon";

var _default = (0, _styledComponents.withTheme)(Icon);

exports["default"] = _default;
//# sourceMappingURL=Icon.js.map